// jQuery
jQuery(function ($) {
  // -----------------------------
  // totop
  // -----------------------------
  // ボタンをクリックしたらスクロールして上に戻る
  var topBtn = $('.totop');

  topBtn.click(function () {
    $('body,html').animate({
      scrollTop: 0
    }, 300, 'swing');
    return false;
  });
});

// JavaScript

// 
// hamburgerのJS
// 

document.addEventListener("DOMContentLoaded", function () {
  const toggleButton = document.querySelector(".hamburger");
  const menuBody = document.querySelector("#nav-menu");
  const hamburgerLine = document.querySelector(".hamburger-icon"); // ハンバーガーアイコンの線を取得
  const overlay = document.querySelector(".header");
  const menuLinks = menuBody.querySelectorAll("a"); // メニュー内のすべてのリンクを取得

  // ハンバーガーアイコンのクリックでメニューを開閉
  toggleButton.addEventListener("click", function () {
    const isOpen = toggleButton.getAttribute("aria-expanded") === "true";

    // aria属性の更新
    toggleButton.setAttribute("aria-expanded", !isOpen);
    menuBody.setAttribute("aria-hidden", isOpen ? "true" : "false");

    // クラスの切り替え
    toggleButton.classList.toggle("_open")
    menuBody.classList.toggle("_open");
    hamburgerLine.classList.toggle("_open"); // ハンバーガーアイコンの線にもクラスを付与
    overlay.classList.toggle("_open");
  });

  // メニュー外クリックで閉じる
  document.addEventListener("click", function (e) {
    if (!menuBody.contains(e.target) && !toggleButton.contains(e.target)) {
      toggleButton.classList.remove("_open")
      menuBody.classList.remove("_open");
      hamburgerLine.classList.remove("_open"); // ハンバーガーアイコンの線からもクラスを削除
      overlay.classList.remove("_open");
      toggleButton.setAttribute("aria-expanded", "false");
      menuBody.setAttribute("aria-hidden", "true");
    }
  });

  // メニュー内のリンクをクリックしたらメニューを閉じる
  menuLinks.forEach(link => {
    link.addEventListener("click", function () {
      menuBody.classList.remove("_open");
      hamburgerLine.classList.remove("_open");
      overlay.classList.remove("_open");
      toggleButton.setAttribute("aria-expanded", "false");
      menuBody.setAttribute("aria-hidden", "true");
    });
  });
});


//
// mvを抜けたらheaderの背景が白くなる
// 

document.addEventListener("DOMContentLoaded", function () {
  // `.header` クラスを持つ要素を取得
  const header = document.querySelector(".header");
  // `.mv` クラスを持つ要素を取得
  const mvSection = document.querySelector(".mv");

  // `.header` が存在しない場合は処理を終了（エラー防止）
  if (!header) return;

  // `.mv` が存在しない場合は、最初から `_visible` クラスを追加
  if (!mvSection) {
    header.classList.add("_visible");
    return;
  }

  // ヘッダーの表示状態を切り替える関数を定義
  function toggleHeaderClass() {
    // `.mv` セクションの下端の位置を取得
    const mvBottom = mvSection.getBoundingClientRect().bottom;

    // `.mv` セクションが画面外（上方向）に完全に出た場合
    if (mvBottom <= 0) {
      // ヘッダーに `_visible` クラスを追加
      header.classList.add("_visible");
    } else {
      // `.mv` セクションがまだ画面内にある場合、 `_visible` クラスを削除
      header.classList.remove("_visible");
    }
  }

  // スクロールイベントが発生するたびに `toggleHeaderClass` 関数を実行
  window.addEventListener("scroll", toggleHeaderClass);
});

// 
// MVのNEWSのスライド
// 
document.addEventListener("DOMContentLoaded", function () {
  const newsWrap = document.querySelector(".mvNews-wrap");
  const newsItems = document.querySelectorAll(".mvNews-link");
  let currentIndex = 0;

  if (newsItems.length <= 1) return; // 1件以下なら処理しない

  // 初期設定
  newsItems.forEach((item, index) => {
    item.style.transform = `translateY(${index === 0 ? 0 : 100}%)`;
    item.style.opacity = index === 0 ? 1 : 0;
  });

  function showNextNews() {
    const currentItem = newsItems[currentIndex];
    const nextIndex = (currentIndex + 1) % newsItems.length;
    const nextItem = newsItems[nextIndex];

    // 現在のアイテムを上にスライドアウト
    currentItem.style.transition = "transform 0.6s ease-in-out, opacity 0.6s ease-in-out";
    currentItem.style.transform = "translateY(-100%)";
    currentItem.style.opacity = 0;

    // 次のアイテムを下からスライドイン
    nextItem.style.transition = "transform 0.6s ease-in-out, opacity 0.6s ease-in-out";
    nextItem.style.transform = "translateY(0)";
    nextItem.style.opacity = 1;

    // 一定時間後に現在のアイテムをリセット
    setTimeout(() => {
      currentItem.style.transition = "none";
      currentItem.style.transform = "translateY(100%)";
    }, 600);

    currentIndex = nextIndex;
  }

  setInterval(showNextNews, 3000); // 3秒ごとに切り替え
});

// 
// MVの画像の切り替え
// 
document.addEventListener('DOMContentLoaded', () => {
  const images = document.querySelectorAll('.mv-imgWrap img');
  const paginationContainer = document.querySelector('.mv-pagination');

  // 要素が存在しない場合は処理を中止
  if (images.length === 0 || !paginationContainer) return;

  let currentIndex = 0;



  // ページネーションのドットを画像の数に応じて生成
  images.forEach((_, index) => {
    const dot = document.createElement('div');
    dot.classList.add('dot');
    if (index === 0) dot.classList.add('_active'); // 最初のドットをアクティブに
    paginationContainer.appendChild(dot);
  });

  const dots = document.querySelectorAll('.mv-pagination .dot');

  // 初期状態で最初の画像を表示
  images[currentIndex].classList.add('_active');

  // 3秒ごとに画像とページネーションを切り替える
  setInterval(() => {
    // 現在の画像とドットのアクティブクラスを削除
    images[currentIndex].classList.remove('_active');
    dots[currentIndex].classList.remove('_active');

    // 次の画像に更新
    currentIndex = (currentIndex + 1) % images.length;

    // 次の画像とドットにアクティブクラスを追加
    images[currentIndex].classList.add('_active');
    dots[currentIndex].classList.add('_active');
  }, 9000);
});

//
// タブ切り替え
// 


document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll(".tabs");

  tabs.forEach(tabContainer => {
    const buttons = tabContainer.querySelectorAll(".tabs-btn");
    const contents = tabContainer.querySelectorAll(".tabs-cont");

    function activateTab(tabId, updateHash = true) {
      buttons.forEach(btn => btn.classList.remove("_active"));
      contents.forEach(content => content.classList.remove("_active"));

      const activeButton = tabContainer.querySelector(`.tabs-btn[data-tab="${tabId}"]`);
      const activeContent = tabContainer.querySelector(`#${tabId}`);

      if (activeButton && activeContent) {
        activeButton.classList.add("_active");
        activeContent.classList.add("_active");

        // URLのハッシュを更新（updateHashがtrueの場合のみ）
        if (updateHash) {
          history.pushState(null, "", `#${tabId}`);
        }
      }
    }

    buttons.forEach(button => {
      button.addEventListener("click", () => {
        const tabId = button.dataset.tab;
        activateTab(tabId);
      });
    });

    // **URLのハッシュからタブを開く（tabs を含むIDのみ認識）**
    const hash = window.location.hash.substring(1);
    if (hash && hash.includes("tabs") && document.getElementById(hash)) {
      activateTab(hash, false); // 初回ロード時は履歴を更新しない
    }

    // **ハッシュ変更時にタブを切り替える（tabs を含むIDのみ認識）**
    window.addEventListener("hashchange", () => {
      const newHash = window.location.hash.substring(1);
      if (newHash && newHash.includes("tabs") && document.getElementById(newHash)) {
        activateTab(newHash, false);
      }
    });
  });
});



// 
// テキストのJS
// 

document.addEventListener("DOMContentLoaded", () => {
  const targets = document.querySelectorAll(".js-txt");

  // 要素が存在しない場合は処理を中止
  if (targets.length === 0) return;

  targets.forEach(target => {
    // テキストを1文字ずつ<span>で囲む
    const text = target.textContent;
    target.innerHTML = "";
    text.split("").forEach((char, index) => {
      const span = document.createElement("span");
      span.textContent = char;
      span.style.animationDelay = `${index * 0.05}s`;
      target.appendChild(span);
    });
  });

  // スクロール時に発火するIntersectionObserver
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add("_visible");
        observer.unobserve(entry.target); // 1度発火したら監視を解除
      }
    });
  }, { threshold: 0.1 });

  targets.forEach(target => observer.observe(target));
});


// 
// プライバシーポリシーに同意の一部をリンクにする
// 

document.addEventListener("DOMContentLoaded", function () {
  const privacyContainer = document.querySelector(".contactForm-privacy .wpcf7-list-item-label");

  if (privacyContainer && wpData.privacyPolicyURL) {
    privacyContainer.innerHTML = privacyContainer.innerHTML.replace(
      "プライバシーポリシー",
      '<a href="' + wpData.privacyPolicyURL + '" target="_blank" rel="noopener noreferrer">プライバシーポリシー</a>'
    );
  }
});


